import {
  Button,
  DatePicker,
  Input,
  Modal,
  Select,
  Skeleton,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import {
  dispatchtoast,
  formatDateAndTime,
  setLocalStorageItem,
  trimString,
} from "../../../Utils";
import dayjs from "dayjs";
import ReportDrawer from "../../../Common/ReportDrawer";
import { AiOutlineSearch } from "react-icons/ai";
import { setselectedTab } from "../../../Store/B2bslice";
import { useDispatch } from "react-redux";
import CommonInput from "../../../Common/CommonInput";
import CommonPagination from "../../../Common/Pagination";
import {
  getPpifundTransferReport,
  PPIFundTransfergetRefund,
  resendOtpPPIdmtFundTransfer,
} from "../../../ApiServices/Apifun";
import useOtpHook from "../../../Hooks/useOtpHook";

const PpifundTransferReport = () => {
  const dispatch = useDispatch();
  const [dataSource, setDataSource] = useState([]);
  const [current, setCurrent] = useState(1);
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [searchcolumn, setSearchColumn] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);
  const [result, setResult] = useState(null);
  const [searchOptions, setSearchOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [record, setRecord] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const { handleChange, handleKeyUp, pin, inputRefs } = useOtpHook(6);
  const [stateResp, setStateResp] = useState("");
  const ReportColumn = [
    {
      title: "Date",
      dataIndex: "Date",
      key: "Date",
      render: (text) => <p className="font-medium w-[150px]">{text}</p>,
    },
    {
      title: "Transaction Id",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (text) => {
        return (
          <>
            <p className=" font-medium ">{text}</p>
          </>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "beneficiary_name",
      key: "beneficiary_name",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Account",
      dataIndex: "account_no",
      key: "account_no",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "IFSC Code",
      dataIndex: "ifsc_code",
      key: "ifsc_code",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Bank ",
      dataIndex: "bank_name",
      key: "bank_name",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Transfer Mode",
      dataIndex: "transfer_mode",
      key: "transfer_mode",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text}
        </p>
      ),
    },
    {
      title: "Surcharge",
      dataIndex: "surcharge",
      key: "surcharge",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text} Rs.
        </p>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text} Rs.
        </p>
      ),
    },
    {
      title: "RRN",
      dataIndex: "rrn",
      key: "rrn",
      render: (text) => (
        <p style={{ width: "80px" }} className=" font-medium">
          {text} Rs.
        </p>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, record) => {
        return (
          <div>
            {text === "0" ? (
              <Tag color="yellow"> Pending</Tag>
            ) : text === "1" ? (
              <Tag color="green">Success</Tag>
            ) : text === "2" ? (
              <Tag color="red">Failed</Tag>
            ) : text === "3" ? (
              <Button
                size="small"
                className="bg-primary text-white"
                onClick={() => {
                  setRecord(record);
                  handleResendOTP(record);
                }}
              >
                Proceed to Refund
              </Button>
            ) : (
              <Tag color="orange">Refunded</Tag>
            )}
          </div>
        );
      },
    },
    {
      title: "Remarks",
      dataIndex: "remark",
      key: "remark",
      render: (text) => {
        return (
          <>
            <Tooltip title={text}>
              <p className="font-medium w-[200px] overflow-y-scroll">
                {text ? text : "NAN"}
              </p>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const getReport = (
    search_keyword = searchKeyword,
    search_column = searchcolumn,
    from_date = fromDate,
    to_date = toDate
  ) => {
    setLoading(true);
    const payload = {
      per_page: pageSize,
      page_no: current,
      search_keyword: search_keyword,
      search_column: search_column,
      from_date: from_date,
      to_date: to_date,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    getPpifundTransferReport(formdata)
      .then((res) => {
        setDataSource(res.data);
        setTotalPages(res.total);
        setSearchOptions(
          res?.filter_column_name?.map((i, index) => {
            return {
              label: i,
              value: res.filter_column_key[index],
            };
          })
        );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  const handleResendOTP = (val) => {
    console.log(val, "valuable record");
    const formdata = new FormData();
    formdata.append("transaction_id", val.transaction_id);
    resendOtpPPIdmtFundTransfer(formdata)
      .then((res) => {
        if (res.status) {
          setStateResp(res.data.stateresp);
          setIsOpen(true);
          // setHide(true);
          // setOpenVerifyModal(true);
        } else {
          setIsOpen(false);
        }
      })
      .catch((err) => console.log(err));
  };
  const handleVerify = (val) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("otp", pin.join(""));
    formdata.append("transaction_id", record.transaction_id);
    formdata.append("stateresp", stateResp);

    PPIFundTransfergetRefund(formdata)
      .then((res) => {
        if (res?.status) {
          dispatchtoast("Refund Initiated Successfully", false);
          getReport();
          setBtnLoading(false);
        } else {
          dispatchtoast("Something went wrong", true);
          setBtnLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setBtnLoading(false);
      })
      .finally(() => {
        setBtnLoading(false);
        setIsOpen(false);
      });
  };
  useEffect(() => {
    getReport();
  }, [current, pageSize]);
  useEffect(() => {
    dispatch(setselectedTab("11.92"));
  }, []);
  const Content = () => {
    return (
      <>
        <div className="border-2 rounded-md w-9/12 border-dashed border-gray-500  ml-4 mr-4 text-center mt-5">
          <p className="-mt-2 bg-white w-[100px] flex justify-center items-center font-semibold m-auto text-[11px]">
            Transaction I'd
          </p>
          <p className="text-[11px] mt-2 mb-2">{result?.transaction_id}</p>
        </div>
        <div className="text-[11px] border-b-[1px] py-3 border-dashed border-gray-500 w-9/12 text-gray-600 mt-4 ">
          <div className="flex justify-between items-center">
            <p>Transaction Date</p>
            <p className="text-black">{result?.Date ?? "-"}</p>
          </div>
        </div>
        <div className="text-[11px] border-b-[1px] py-[6px] border-dashed border-gray-500 w-9/12 text-gray-600 mt-2 ">
          <div className="flex justify-between items-center">
            <p>Name</p>
            <p className="text-black">{result?.beneficiary_name}</p>
          </div>
        </div>
        <div className="text-[11px] border-b-[1px] py-[6px] border-dashed border-gray-500 w-9/12 text-gray-600 mt-2 ">
          <div className="flex justify-between items-center">
            <p>Account</p>
            <p className="text-black">{result?.account_no}</p>
          </div>
        </div>
        <div className="text-[11px] border-b-[1px] py-[6px] border-dashed border-gray-500 w-9/12 text-gray-600 mt-2 ">
          <div className="flex justify-between items-center">
            <p>Bank name</p>
            <p className="text-black">{result?.bank_name}</p>
          </div>
        </div>
        <div className="text-[11px] border-b-[1px] py-[6px] border-dashed border-gray-500 w-9/12 text-gray-600 mt-2 ">
          <div className="flex justify-between items-center">
            <p>IFSC</p>
            <p className="text-black">{result?.ifsc_code}</p>
          </div>
        </div>
        <div className="text-[11px] border-b-[1px] py-[6px] border-dashed border-gray-500 w-9/12 text-gray-600 mt-2 ">
          <div className="flex justify-between items-center">
            <p>Amount</p>
            <p className="text-black">{result?.amount}</p>
          </div>
        </div>
        <div className="text-[11px] border-b-[1px] py-[6px] border-dashed border-gray-500 w-9/12 text-gray-600 mt-2 ">
          <div className="flex justify-between items-center">
            <p>Surcharge</p>
            <p className="text-black">{result?.surcharge}</p>
          </div>
        </div>

        <div className="text-[11px] border-b-[1px] py-[6px] border-dashed border-gray-500 w-9/12 text-gray-600 mt-2 ">
          <div className="flex justify-between items-center">
            <p>Remark</p>
            <p className="text-black">{result?.remark}</p>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <div className="">
        <div className="prepaid  animate-fade-in w-full  bg-white shadow-normal  rounded-xl p-4">
          <div className="flex justify-between items-center">
            <p className="font-bold text-[15px] mb-2">Fund Transfer Report</p>
            <p
              onClick={() => {
                getReport("", "", "", "");
                setSearchKeyWord("");
                setSearchColumn(null);
                setFromDate("");
                setToDate("");
              }}
              className="font-medium text-xs cursor-pointer bg-bsred hover:bg-red-600 text-white px-2 py-1 rounded-md text-[15px] mb-2"
            >
              Clear Filter
            </p>
          </div>
          <div className="selectionFields grid grid-cols-1 md:grid-cols-3 gap-4 place-items-center ">
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                Select Search Type
              </p>
              <Select
                placeholder="Select search type"
                value={searchcolumn}
                onChange={(val) => setSearchColumn(val)}
                className="w-full mt-2"
                options={searchOptions}
              />
            </div>
            <div className="w-full">
              <p className={`required text-textGray `}>Keyword</p>
              {searchcolumn === "wallet.created_at" ? (
                <DatePicker
                  // value={dayjs("2023-09-07","YYYY-MM-DD")}
                  popupClassName="bottom-calendar"
                  allowClear
                  // value={searchKeyword}
                  className="w-full datepicker mt-4"
                  onChange={(val) =>
                    setSearchKeyWord(dayjs(val).format("YYYY-MM-DD"))
                  }
                  placement="bottomLeft"
                  placeholder="Search"
                />
              ) : (
                <CommonInput
                  placeholder="Seacrh"
                  value={searchKeyword}
                  onChange={(e) => setSearchKeyWord(e.target.value)}
                  className="outline-none text-xs border mt-4 w-full  border-gray-200 focus:border-primary   px-2 "
                />
              )}
            </div>
            <div className="w-full">
              <p className={`required text-textGray mt-2`}>
                From Date - To Date
              </p>
              <DatePicker.RangePicker
                allowClear
                onChange={(val) => {
                  setFromDate(val ? dayjs(val[0]).format("YYYY-MM-DD") : "");
                  setToDate(val ? dayjs(val[1]).format("YYYY-MM-DD") : "");
                }}
                className="w-full mt-2"
              />
            </div>{" "}
          </div>
          <div className="w-full flex justify-end items-center mt-3">
            <Button
              // disabled=
              onClick={() => getReport()}
              style={{ color: "white" }}
              className=" font-semibold flex justify-between gap-2 items-center hover:bg-primaryhover bg-primary border-none"
            >
              <AiOutlineSearch />
              <p>Search</p>
            </Button>
          </div>
        </div>
      </div>
      <div>
        <div className="mt-4">
          <Spin spinning={loading}>
            <Table
              className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
              columns={ReportColumn}
              pagination={false}
              onRow={(record, rowIndex) => {
                const isClickable = record.status !== "3";

                return {
                  onClick: isClickable
                    ? (event) => {
                        setResult(record);
                        setOpenReceiptDrawer(true);
                      }
                    : undefined,
                  className: isClickable
                    ? "cursor-pointer text-[12px]"
                    : "text-[12px]",
                };
              }}
              dataSource={dataSource}
            />
            <div className="mt-2 mb-8 flex justify-end items-center">
              <CommonPagination
                totalPages={totalPages}
                current={current}
                pageSize={pageSize}
                setCurrent={setCurrent}
                setPageSize={setPageSize}
              />
            </div>
          </Spin>
        </div>
      </div>
      {isOpen && (
        <Modal
          title="Verify OTP"
          footer={null}
          className="shadow-normal"
          width={300}
          maskClosable={false}
          open={isOpen}
          onCancel={() => setIsOpen(false)}
        >
          <div className="  rounded-3xl shadow-normal bg-white ">
            <>
              <div className="header flex flex-col justify-center items-center">
                <p className="text-[15px] mt-3 text-gray-500">Enter OTP</p>
              </div>
              <div className=" mt-5 flex justify-center items-center">
                {[1, 2, 3, 4, 5, 6].map((i, index) => {
                  return (
                    <>
                      <input
                        key={index}
                        ref={inputRefs[index]}
                        type="text"
                        maxLength={1}
                        className="w-[15px] otpinput xs:w-[35px] sm:w-[35px] md:w-[40px] text-bsblackrgb rounded-md bg-gray-300 h-8  mx-1 border-none focus:outline-none focus:border-none text-center"
                        value={pin[index]}
                        onChange={(e) => handleChange(index, e.target.value)}
                        onKeyUp={(e) => handleKeyUp(index, e)}
                      />
                    </>
                  );
                })}
              </div>
              <Button
                loading={btnLoading}
                onClick={() => pin.length === 6 && handleVerify()}
                className={`SignInBtn w-full ${
                  pin.length === 6 ? "cursor-pointer" : "cursor-not-allowed"
                }  mt-4 ${
                  pin.length === 6 ? "bg-primary" : "bg-bsgray"
                }  flex justify-center border-none items-center h-12 mt-10 rounded-full text-white text-[12px] font-bold`}
              >
                <p>Refund Initiated</p>
              </Button>
            </>
          </div>
        </Modal>
      )}

      {openReceiptDrawer && (
        <ReportDrawer
          title={"Fund Transfer Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content />}
        />
      )}
    </>
  );
};

export default PpifundTransferReport;
